import { Person } from "@models/users/person";

export const NULL_GUID = '00000000-0000-0000-0000-000000000000';
export const SYSTEM_USER_ID = '00000000-0000-0000-0000-000000000000';
export const SYSTEM_USER = new Person({ id: SYSTEM_USER_ID, firstName: '<VIZORRO>', avatar: './assets/icons/icon-96x96.png' });
